import React from 'react';
import { motion } from 'framer-motion';
import { images } from '../../constants';
import './imageside.scss';

const Imageside = () => (
  <motion.div className="app__imageside">
    <motion.img
      src={images.collins}
      alt="Collins"
      whileInView={{ scale: [0, 1], opacity: [0, 1] }}
      transition={{ duration: 1.5, ease: 'easeInOut' }}
    />
  </motion.div>
);

export default Imageside;
